module.exports = __webpack_public_path__ + "static/media/bsong.8c35ba48.svg";